import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'
import DazzedParagraph12 from 'components/common/text/DazzedParagraph12'
import { OralScoreColorCodes } from 'consts/oralScoreConsts'

const TOOLTIPS_KEY = 'pages.patients.selectedPatient.timelineV2.oralScores.findingsCard.tooltips'

const useStyles = makeStyles(() => ({
  summary: {
    color: '#000',
    marginBottom: 6
  },
  level: {
    color: '#000',
    '&:not(:last-child)': {
      marginBottom: 4
    }
  },
  levelLabel: {
    fontWeight: 500
  }
}))

/**
 * Explains one suggested finding: a summary line, then every possible value with its color and meaning.
 */
const OralScoreFindingTooltip = ({ category, levels }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <div>
      <DazzedParagraph12 thickness="strong" className={classes.summary}>
        {t(`${TOOLTIPS_KEY}.${category}.summary`)}
      </DazzedParagraph12>
      {levels.map(level => (
        <DazzedParagraph12 key={level} thickness="thin" className={classes.level}>
          <span className={classes.levelLabel} style={{ color: OralScoreColorCodes[level] }}>
            {t(`${TOOLTIPS_KEY}.levels.${level}`)} -{' '}
          </span>
          {t(`${TOOLTIPS_KEY}.${category}.${level}`)}
        </DazzedParagraph12>
      ))}
    </div>
  )
}

export default OralScoreFindingTooltip
